module.exports = __webpack_public_path__ + "img/xml.94758746.svg";